import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '../../../Checkbox';
import './LegendModalRow.css';

export function LegendModalRow(props) {
  const { lineStyle, name, number, id, status, isSelected, isDisabled, onClick } = props;

  let rowClass = 'legend-modal-row';
  rowClass = isSelected ? `${rowClass} ${rowClass}--selected` : `${rowClass}`;
  rowClass = isDisabled ? `${rowClass} ${rowClass}--disabled` : `${rowClass}`;
  const columnClass = 'legend-modal__column';
  const selectedLineClass = isSelected ? `line ${lineStyle}` : '';

  return (
    <label htmlFor={id}>
      <div className={rowClass}>
        <div className={columnClass}>
          <Checkbox checked={isSelected} id={id} onChange={() => onClick(id)} isDisabled={isDisabled} />
        </div>
        <div className={`${columnClass} legend-modal__column--desktop`}>
          <div className={selectedLineClass} />
        </div>
        {number !== '' ? <div className={columnClass}>{number}</div> : null}
        <div className={`${columnClass} legend-modal__column--wide`}>{name}</div>
        <div className={`${columnClass} legend-modal__column--desktop`}>{status}</div>
      </div>
    </label>
  );
}

LegendModalRow.propTypes = {
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  lineStyle: PropTypes.string,
  id: PropTypes.string,
  number: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

LegendModalRow.defaultProps = {
  isDisabled: false,
  isSelected: false,
  lineStyle: '',
  id: '',
  number: '',
  name: '',
  status: '',
};
